import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DyButtonComponent } from '../../../components/form-fields/dy-button/dy-button.component';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { clearAuthStorage } from '../../../utilities/auth-storage';

@Component({
  selector: 'cricteams-admin-sectionheader',
  standalone: true,
  imports: [CommonModule,DyButtonComponent,],
  templateUrl: './admin-sectionheader.component.html',
  styleUrl: './admin-sectionheader.component.scss',
})
export class AdminSectionheaderComponent {
  btnClass =
    'max-w-fit text-white text-xs font-semibold bg-dark-blue hover:bg-darkBlue transition duration-700 ease-in-out p-3 w-full';
    constructor(
      private authService: AuthService,
      private router: Router,
    ) {
    }



    logout() {
      this.authService.logout();
      localStorage.removeItem('access_token');
      clearAuthStorage();        
      this.router.navigateByUrl('home');
    }
}
